import { gql } from '@apollo/client';

export default gql`
  mutation createDiscount(
    $type: CreatableDiscountType!
    $currency: Currency!
    $value: Float!
    $recipientEmail: String
    $firstName: String
    $lastName: String
    $associatedPNR: String
    $productsRestriction: [DiscountProductRestrictions!]
    $actionBy: String
    $businessAccount: String
    $salesPeriodStart: String!
    $salesPeriodEnd: String!
    $travelPeriodStart: String!
    $travelPeriodEnd: String!
    $maximumNumberOfPaxs: Int
    $tripRestrictions: DiscountTripRestrictions
    $countriesRestrictions: [String!]
  ) {
    createDiscount(
      type: $type
      currency: $currency
      value: $value
      recipientEmail: $recipientEmail
      firstName: $firstName
      lastName: $lastName
      associatedPNR: $associatedPNR
      productsRestriction: $productsRestriction
      actionBy: $actionBy
      businessAccount: $businessAccount
      salesPeriodStart: $salesPeriodStart
      salesPeriodEnd: $salesPeriodEnd
      travelPeriodStart: $travelPeriodStart
      travelPeriodEnd: $travelPeriodEnd
      maximumNumberOfPaxs: $maximumNumberOfPaxs
      tripRestrictions: $tripRestrictions
      countriesRestrictions: $countriesRestrictions
    ) {
      reference
      alias
      type
      amount
      currency
      validUntil
    }
  }
`;
